import { Box, Typography, useTheme } from '@mui/material';
import { studentProgressCountStyles } from './StudentProgressCount.styles';
import StudentIcon from './images/student.svg';

export interface StudentProgressCountProps {
  progressedStudents: number;
  invitedStudents: number;
}

export const StudentProgressCount = ({
  progressedStudents,
  invitedStudents,
}: StudentProgressCountProps) => {
  const theme = useTheme();

  return (
    <Box sx={studentProgressCountStyles.container(theme)} aria-label={`${progressedStudents}/${invitedStudents} students started`}>
      <Box
        component="img"
        src={StudentIcon}
        alt=""
        aria-hidden={true}
        sx={studentProgressCountStyles.icon(theme)}
      />
      <Typography component="span" sx={studentProgressCountStyles.text(theme)}>
        {progressedStudents}/{invitedStudents}
      </Typography>
    </Box>
  );
};

export default StudentProgressCount;
